const toComparableTimestamp = (value) => {
    if (!value) {
        return null;
    }

    const date = new Date(value.replace(' ', 'T'));
    return Number.isNaN(date.getTime()) ? null : date.getTime();
};

/**
 * @param {string|null|undefined} timestamp
 * @param {string|null|undefined} windowStart
 * @param {string|null|undefined} windowEnd
 * @returns {boolean}
 */
export const isTimestampInWindow = (timestamp, windowStart, windowEnd) => {
    const value = toComparableTimestamp(timestamp);
    if (value == null) {
        return false;
    }

    const start = toComparableTimestamp(windowStart);
    const end = toComparableTimestamp(windowEnd);

    if (start != null && value < start) {
        return false;
    }

    if (end != null && value > end) {
        return false;
    }

    return true;
};

/**
 * @param {string|null|undefined} start
 * @param {string|null|undefined} end
 * @returns {{ start: string|null, end: string|null }}
 */
export const normalizeTimeWindow = (start, end) => ({
    start: start || null,
    end: end || null,
});
